import * as DateSelector from '../../components/date-selector'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const fetch: any =
  (community: DateSelector.CommunityIdentifier, date: DateSelector.SelectedDate, limit: number) =>
  Request.requestActionCreator(Constants.FETCH_DROPS)
  ({
    method: 'GET',
    url: `/drops/${community}/${date.format('YYYY-MM-DD')}?limit=${limit}`,
  })

export const clearDrop: any =
  (drop: Types.Drop) =>
  Request.requestActionCreator(Constants.CLEAR_DROP)
  ({
    method: 'DELETE',
    payload: [drop],
    url: `/drops/${drop.community}`,
  })

export const clearDrops: any =
  (community: DateSelector.CommunityIdentifier, drops: Types.Drop[]) =>
  Request.requestActionCreator(Constants.CLEAR_DROP)
  ({
    method: 'DELETE',
    payload: drops,
    url: `/drops/${community}`,
  })

export const updateSelectedDate = (date: DateSelector.SelectedDate) =>
  ({type: Constants.UPDATE_SELECTED_DATE, date})

export const updateFilter = (filter: string) =>
  ({type: Constants.UPDATE_FILTER, filter})



// WEBPACK FOOTER //
// ./src/pages/drops/actions.ts